import DropdownItem from '../DropdownItem'

const SingleItemList = ({ item, onClick: closeDropdown }) =>
  <DropdownItem
    title={item.title}
    href={item.href}
    onClick={(e) => {
      item.onClick(e)
      closeDropdown()
    }}
    variant={item.variant}
    customClass={item.class}
    value={item.value}
  />

export default SingleItemList
